import {styled} from "@mui/material";
import React, {FC} from "react";
import {CircularProgress} from "@material-ui/core";

const WrapperLoading = styled('div')`
  position: absolute;
  background: rgb(0 0 0 / 34%);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

type PropsType = {
  visible: boolean
}

const AbsoluteLoading: FC<PropsType> = ({visible}) => {
  return (
    <>
      {visible ? (
        <WrapperLoading>
          <CircularProgress color="secondary" />
        </WrapperLoading>
      ) : null}
    </>
  )
}

export default AbsoluteLoading